<!--
 * @Descripttion: 
 * @version: 
 * @Author: Raoxf
 * @Date: 2022-12-21 21:30:39
 * @LastEditors: Raoxf
 * @LastEditTime: 2022-12-29 21:17:52
-->
<template>
  <div>
    <search-area
      tabName="合伙人申请列表"
      @search="search"
      searchExport
      @goexport="goexportPatner"
    >
      <Form
        ref="searchParam"
        :model="searchParam"
        :label-width="55"
        inline
        label-position="right"
        label-colon
      >
        <FormItem label="联系人" prop="userName" :label-width="105">
          <Input
            v-model="searchParam.userName"
            placeholder="请输入姓名"
            style="width: 200px"
            clearable
            @on-change="search(1)"
          ></Input>
        </FormItem>
        <FormItem label="手机号" prop="phone" :label-width="105">
          <Input
            v-model="searchParam.phone"
            placeholder="请输入手机号"
            style="width: 200px"
            clearable
            @on-change="search(1)"
          ></Input>
        </FormItem>
        <FormItem label="审核状态" prop="reviewStatus" :label-width="105">
          <Select
            v-model="searchParam.reviewStatus"
            style="width: 160px"
            @on-change="search(1)"
            clearable
          >
            <Option
              v-for="item in reviewStatusList"
              :value="item.code"
              :key="item.code"
              >{{ item.value }}</Option
            >
          </Select>
        </FormItem>
      </Form>
    </search-area>
    <table-area
      :columns="columns"
      :data="userList"
      :total="total"
      @search="search"
      :pageNum="searchParam.currentPage"
      :pageSize="searchParam.pageSize"
    ></table-area>
    <el-dialog
      title="审核招募申请"
      :visible.sync="showReviewDialog"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        ref="reviewFormData"
        :model="reviewFormData"
        :rules="reviewRule"
        label-width="120px"
      >
        <el-form-item label="审核状态" prop="state">
          <el-select
            v-model="reviewFormData.state"
            placeholder="请选择审核状态"
          >
            <el-option label="通过" value="1" />
            <el-option label="拒绝" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="String(reviewFormData.state) === '2'"
          label="拒绝原因"
          prop="reason"
        >
          <el-input
            v-model="reviewFormData.reason"
            placeholder="请输入拒绝原因"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
        <el-form-item
          v-if="
            currentReviewRow &&
            currentReviewRow.type == 1 &&
            String(reviewFormData.state) === '1'
          "
          label="服务商名称"
          prop="companyName"
        >
          <el-input
            v-model="reviewFormData.companyName"
            placeholder="请输入服务商名称"
          />
        </el-form-item>
        <el-form-item
          v-if="
            currentReviewRow &&
            currentReviewRow.type == 1 &&
            String(reviewFormData.state) === '1'
          "
          label="服务商编码"
          prop="companyCode"
        >
          <el-input
            v-model="reviewFormData.companyCode"
            placeholder="请输入服务商编码"
          />
        </el-form-item>
        <el-form-item
          v-if="
            currentReviewRow &&
            currentReviewRow.type == 1 &&
            String(reviewFormData.state) === '1'
          "
          label="法人姓名"
          prop="legalPersonName"
        >
          <el-input
            v-model="reviewFormData.legalPersonName"
            placeholder="请输入法人姓名"
          />
        </el-form-item>
        <el-form-item
          v-if="
            currentReviewRow &&
            currentReviewRow.type == 1 &&
            String(reviewFormData.state) === '1'
          "
          label="法人手机号"
          prop="legalPersonPhone"
        >
          <el-input
            v-model="reviewFormData.legalPersonPhone"
            placeholder="请输入法人手机号"
          />
        </el-form-item>
        <el-form-item
          v-if="
            currentReviewRow &&
            currentReviewRow.type == 1 &&
            String(reviewFormData.state) === '1'
          "
          label="营业执照"
          prop="license"
        >
          <div
            v-if="reviewFormData.license"
            style="display: flex; gap: 10px; flex-wrap: wrap"
          >
            <span
              v-for="(img, index) in reviewFormData.license.split(',')"
              :key="index"
              style="display: inline-block; width: 100px; height: 100px"
            >
              <el-popover placement="left" title="" trigger="hover" width="300">
                <img :src="img.trim()" width="100%" />
                <img
                  slot="reference"
                  :src="img.trim()"
                  :alt="`营业执照${index + 1}`"
                  style="
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    cursor: pointer;
                  "
                />
              </el-popover>
            </span>
          </div>
          <span v-else style="color: #999">暂无图片</span>
        </el-form-item>
        <el-form-item
          v-if="
            currentReviewRow &&
            currentReviewRow.type == 1 &&
            String(reviewFormData.state) === '1'
          "
          label="法人身份证照片"
          prop="idCardUrl"
        >
          <div
            v-if="reviewFormData.idCardUrl"
            style="display: flex; gap: 10px; flex-wrap: wrap"
          >
            <span
              v-for="(img, index) in reviewFormData.idCardUrl.split(',')"
              :key="index"
              style="display: inline-block; width: 100px; height: 100px"
            >
              <el-popover placement="left" title="" trigger="hover" width="300">
                <img :src="img.trim()" width="100%" />
                <img
                  slot="reference"
                  :src="img.trim()"
                  :alt="`身份证${index + 1}`"
                  style="
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    cursor: pointer;
                  "
                />
              </el-popover>
            </span>
          </div>
          <span v-else style="color: #999">暂无图片</span>
        </el-form-item>
        <!-- 保洁员审核字段 -->
        <el-form-item
          v-if="
            currentReviewRow &&
            currentReviewRow.type != 1 &&
            String(reviewFormData.state) === '1'
          "
          label="姓名"
          prop="realName"
        >
          <el-input
            v-model="reviewFormData.realName"
            placeholder="请输入姓名"
          />
        </el-form-item>
        <el-form-item
          v-if="
            currentReviewRow &&
            currentReviewRow.type != 1 &&
            String(reviewFormData.state) === '1'
          "
          label="手机号"
          prop="phone"
        >
          <el-input v-model="reviewFormData.phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item
          v-if="
            currentReviewRow &&
            currentReviewRow.type != 1 &&
            String(reviewFormData.state) === '1'
          "
          label="身份证号"
          prop="idNumber"
        >
          <el-input
            v-model="reviewFormData.idNumber"
            placeholder="请输入身份证号"
          />
        </el-form-item>
        <el-form-item
          v-if="
            currentReviewRow &&
            currentReviewRow.type != 1 &&
            String(reviewFormData.state) === '1'
          "
          label="职业证书"
          prop="certificateUrl"
        >
          <div
            v-if="reviewFormData.certificateUrl"
            style="display: flex; gap: 10px; flex-wrap: wrap"
          >
            <span
              v-for="(img, index) in reviewFormData.certificateUrl.split(',')"
              :key="index"
              style="display: inline-block; width: 100px; height: 100px"
            >
              <el-popover placement="left" title="" trigger="hover" width="300">
                <img :src="img.trim()" width="100%" />
                <img
                  slot="reference"
                  :src="img.trim()"
                  :alt="`证书${index + 1}`"
                  style="
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    cursor: pointer;
                  "
                />
              </el-popover>
            </span>
          </div>
          <span v-else style="color: #999">暂无图片</span>
        </el-form-item>
        <el-form-item
          v-if="
            currentReviewRow &&
            currentReviewRow.type != 1 &&
            String(reviewFormData.state) === '1'
          "
          label="身份证正反面"
          prop="idNumberUrl"
        >
          <div
            v-if="reviewFormData.idNumberUrl"
            style="display: flex; gap: 10px; flex-wrap: wrap"
          >
            <span
              v-for="(img, index) in reviewFormData.idNumberUrl.split(',')"
              :key="index"
              style="display: inline-block; width: 100px; height: 100px"
            >
              <el-popover placement="left" title="" trigger="hover" width="300">
                <img :src="img.trim()" width="100%" />
                <img
                  slot="reference"
                  :src="img.trim()"
                  :alt="`身份证${index + 1}`"
                  style="
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    cursor: pointer;
                  "
                />
              </el-popover>
            </span>
          </div>
          <span v-else style="color: #999">暂无图片</span>
        </el-form-item>
        <el-form-item
          v-if="
            currentReviewRow &&
            currentReviewRow.type != 1 &&
            String(reviewFormData.state) === '1'
          "
          label="所属公司"
          prop="companyId"
        >
          <el-select
            v-model="reviewFormData.companyId"
            placeholder="请选择公司"
            style="width: 100%"
          >
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCloseReview">取 消</el-button>
        <el-button type="primary" @click="onSubmitReview">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import columns from "./partner-applicant-config";
export default {
  data() {
    return {
      columns: columns(this),
      // 列表数据总数
      total: 1,
      // 加载中
      loading: false,
      // 搜索参数
      searchParam: {
        currentPage: 1,
        pageSize: 10,
        userName: "", // 昵称
        phone: "", // 手机号
        reviewStatus: "", // 审核状态
      },
      reviewStatusList: [
        { code: 0, value: "待审核" },
        { code: 1, value: "已通过" },
        { code: 2, value: "已拒绝" },
      ],
      userList: [],
      companyList: [],
      showReviewDialog: false,
      reviewFormData: {
        companyName: "",
        companyCode: "",
        legalPersonName: "",
        legalPersonPhone: "",
        license: "",
        idCardUrl: "",
        realName: "",
        phone: "",
        idNumber: "",
        certificateUrl: "",
        idNumberUrl: "",
        companyId: "",
        state: "",
        reason: "",
      },
      currentReviewRow: null,
      reviewRule: {
        companyName: [
          {
            validator: (rule, value, cb) => {
              if (
                this.currentReviewRow &&
                this.currentReviewRow.type == 1 &&
                !value
              ) {
                return cb(new Error("请输入服务商名称"));
              }
              cb();
            },
            trigger: "blur",
          },
        ],
        companyCode: [
          {
            validator: (rule, value, cb) => {
              if (
                this.currentReviewRow &&
                this.currentReviewRow.type == 1 &&
                !value
              ) {
                return cb(new Error("请输入服务商编码"));
              }
              cb();
            },
            trigger: "blur",
          },
        ],
        legalPersonName: [
          {
            validator: (rule, value, cb) => {
              if (
                this.currentReviewRow &&
                this.currentReviewRow.type == 1 &&
                String(this.reviewFormData.state) === "1" &&
                !value
              ) {
                return cb(new Error("请输入法人姓名"));
              }
              cb();
            },
            trigger: "blur",
          },
        ],
        legalPersonPhone: [
          {
            validator: (rule, value, cb) => {
              if (
                this.currentReviewRow &&
                this.currentReviewRow.type == 1 &&
                String(this.reviewFormData.state) === "1"
              ) {
                if (!value) {
                  return cb(new Error("请输入法人手机号"));
                }
                if (!/^1[3456789]\d{9}$/.test(value)) {
                  return cb(new Error("手机号格式不正确"));
                }
              }
              cb();
            },
            trigger: "blur",
          },
        ],
        realName: [
          {
            validator: (rule, value, cb) => {
              if (
                this.currentReviewRow &&
                this.currentReviewRow.type != 1 &&
                String(this.reviewFormData.state) === "1" &&
                !value
              ) {
                return cb(new Error("请输入姓名"));
              }
              cb();
            },
            trigger: "blur",
          },
        ],
        phone: [
          {
            validator: (rule, value, cb) => {
              if (
                this.currentReviewRow &&
                this.currentReviewRow.type != 1 &&
                String(this.reviewFormData.state) === "1"
              ) {
                if (!value) {
                  return cb(new Error("请输入手机号"));
                }
                if (!/^1[3456789]\d{9}$/.test(value)) {
                  return cb(new Error("手机号格式不正确"));
                }
              }
              cb();
            },
            trigger: "blur",
          },
        ],
        idNumber: [
          {
            validator: (rule, value, cb) => {
              if (
                this.currentReviewRow &&
                this.currentReviewRow.type != 1 &&
                String(this.reviewFormData.state) === "1" &&
                !value
              ) {
                return cb(new Error("请输入身份证号"));
              }
              cb();
            },
            trigger: "blur",
          },
        ],
        state: [
          { required: true, message: "请选择审核状态", trigger: "change" },
        ],
        reason: [
          {
            validator: (rule, value, cb) => {
              if (String(this.reviewFormData.state) === "2" && !value) {
                return cb(new Error("请输入拒绝原因"));
              }
              cb();
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  created() {
    this.getUserList();
    this.getCompanyList();
  },
  methods: {
    search(val) {
      this.searchParam.currentPage = val || 1;
      this.getUserList();
    },
    async getUserList() {
      let { list, total } = await this.$post(
        "/partnershipApplicant/listByPage",
        this.searchParam,
      );
      this.userList = list || [];
      this.total = total;
    },
    // 导出
    goexportPatner() {
      this.$blobpost("/partnershipApplicant/exportExcel").then((da) => {
        let blob = new Blob([da.data], {
          type: "application/octet-stream",
        }); // 转化为blob对象
        let filename = "招募信息.xls"; // 判断是否使用默认文件名
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(blob, filename);
        } else {
          var blobURL = window.URL.createObjectURL(blob); // 将blob对象转为一个URL
          var tempLink = document.createElement("a"); // 创建一个a标签
          tempLink.style.display = "none";
          tempLink.href = blobURL;
          tempLink.setAttribute("download", filename); // 给a标签添加下载属性
          if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
          }
          document.body.appendChild(tempLink); // 将a标签添加到body当中
          tempLink.click(); // 启动下载
          document.body.removeChild(tempLink); // 下载完毕删除a标签
          window.URL.revokeObjectURL(blobURL);
        }
      });
    },
    // 打开审核对话框
    openReviewDialog(row) {
      this.currentReviewRow = row;

      // 根据类型初始化表单数据
      if (row.type == 1) {
        // 服务商
        this.reviewFormData = {
          companyName: row.userName || "",
          companyCode: "",
          legalPersonName: "",
          legalPersonPhone: row.phone || "",
          license: row.images || "",
          idCardUrl:
            row.idcardsFront && row.idcardsBack
              ? `${row.idcardsFront},${row.idcardsBack}`
              : row.idcardsFront || row.idcardsBack || "",
          realName: "",
          phone: "",
          idNumber: "",
          certificateUrl: "",
          idNumberUrl: "",
          companyId: "",
          state: "",
          reason: "",
        };
      } else {
        // 保洁员
        this.reviewFormData = {
          companyName: "",
          companyCode: "",
          legalPersonName: "",
          legalPersonPhone: "",
          license: "",
          idCardUrl: "",
          realName: row.userName || "",
          phone: row.phone || "",
          idNumber: "",
          certificateUrl: row.images || "",
          idNumberUrl:
            row.idcardsFront && row.idcardsBack
              ? `${row.idcardsFront},${row.idcardsBack}`
              : row.idcardsFront || row.idcardsBack || "",
          companyId: "",
          state: "",
          reason: "",
        };
      }

      this.showReviewDialog = true;
    },
    // 关闭审核对话框
    onCloseReview() {
      this.showReviewDialog = false;
      this.reviewFormData = {
        companyName: "",
        companyCode: "",
        legalPersonName: "",
        legalPersonPhone: "",
        license: "",
        idCardUrl: "",
        realName: "",
        phone: "",
        idNumber: "",
        certificateUrl: "",
        idNumberUrl: "",
        companyId: "",
        state: "",
        reason: "",
      };
      this.currentReviewRow = null;
      if (this.$refs.reviewFormData) {
        this.$refs.reviewFormData.resetFields();
      }
    },
    // 提交审核
    onSubmitReview() {
      this.$refs.reviewFormData.validate(async (valid) => {
        if (!valid) return;

        const row = this.currentReviewRow;
        if (!row) return;

        try {
          if (row.type == 1) {
            // 服务商使用 /company/save
            const payload = {
              companyId: row.id,
              name: this.reviewFormData.companyName,
              code: this.reviewFormData.companyCode,
              state: this.reviewFormData.state,
            };
            if (String(this.reviewFormData.state) === "1") {
              // 审核通过时添加法人信息
              payload.legalPersonName = this.reviewFormData.legalPersonName;
              payload.legalPersonPhone = this.reviewFormData.legalPersonPhone;
              payload.license = this.reviewFormData.license;
              payload.idCardUrl = this.reviewFormData.idCardUrl;
            }
            if (String(this.reviewFormData.state) === "2") {
              payload.reason = this.reviewFormData.reason;
            }
            await this.$post("/company/save", payload);
          } else {
            // 保洁员使用 /user/addOrEdit
            const payload = {
              userId: row.id,
              type: 2,
              reviewStatus: this.reviewFormData.state === "1" ? "2" : "3",
              reason: this.reviewFormData.reason,
            };

            if (String(this.reviewFormData.state) === "1") {
              // 审核通过时添加保洁员信息
              payload.realName = this.reviewFormData.realName;
              payload.phone = this.reviewFormData.phone;
              payload.idNumber = this.reviewFormData.idNumber;
              payload.certificateUrl = this.reviewFormData.certificateUrl;
              payload.idNumberUrl = this.reviewFormData.idNumberUrl;
              payload.companyId = this.reviewFormData.companyId;
            }

            await this.$post("/user/addOrEdit", payload);
          }

          this.$message.success("审核成功");
          this.onCloseReview();
          this.getUserList();
        } catch (error) {
          console.error("审核失败:", error);
        }
      });
    },
    // 获取公司列表
    async getCompanyList() {
      try {
        this.companyList = await this.$get("/company/all");
      } catch (error) {
        console.error("获取公司列表失败:", error);
      }
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped></style>
